module.exports = __webpack_public_path__ + "img/pop-assets01.60e0d1e4.png";